<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Skeleton from '@uiKit/elements/Skeleton.vue'

// Loading shape of the detail page — the same two-column grid as the real
// content so nothing jumps when the data lands.
</script>

<template>
  <Box class="pd-skeleton" aria-busy="true" aria-label="Loading property">
    <Box direction="col" gap="6">
      <Skeleton animation="wave" width="180px" height="18px" border-radius="6px" />
      <Skeleton
        animation="wave"
        width="100%"
        height="auto"
        border-radius="16px"
        class="pd-skeleton__gallery"
      />
      <Box direction="col" gap="3">
        <Skeleton animation="wave" width="60%" height="28px" border-radius="8px" />
        <Skeleton animation="wave" width="40%" height="20px" border-radius="8px" />
        <Box gap="2">
          <Skeleton
            v-for="chip in 4"
            :key="chip"
            animation="wave"
            width="96px"
            height="28px"
            border-radius="34px"
          />
        </Box>
        <Skeleton animation="wave" width="90%" height="16px" border-radius="6px" />
      </Box>
      <Skeleton animation="wave" width="100%" height="380px" border-radius="14px" />
      <Box gap="4">
        <Skeleton animation="wave" width="100%" height="140px" border-radius="10px" />
        <Skeleton animation="wave" width="100%" height="140px" border-radius="10px" />
      </Box>
    </Box>

    <Box direction="col" gap="4" class="pd-skeleton__rail">
      <Box gap="3">
        <Skeleton animation="wave" width="100%" height="104px" border-radius="16px" />
        <Skeleton animation="wave" width="100%" height="104px" border-radius="16px" />
      </Box>
      <Skeleton animation="wave" width="100%" height="220px" border-radius="14px" />
      <Skeleton animation="wave" width="100%" height="360px" border-radius="14px" />
      <Skeleton animation="wave" width="100%" height="48px" border-radius="12px" />
    </Box>
  </Box>
</template>

<style scoped>
.pd-skeleton {
  display: grid;
  grid-template-columns: minmax(0, 780px) 400px;
  gap: 0 28px;
  align-items: start;
}

.pd-skeleton__gallery {
  aspect-ratio: 728 / 420;
}

@media (max-width: 1200px) {
  .pd-skeleton {
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 0 20px;
  }
}

@media (max-width: 992px) {
  .pd-skeleton {
    grid-template-columns: 1fr;
  }

  .pd-skeleton__rail {
    display: none;
  }
}
</style>
